module.exports = __webpack_public_path__ + "static/media/536SunsetAveNW_2018-06-06_58.1ba3f563.jpg";